import styled from "styled-components";

export const Section = styled.section`
  padding: 0 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const HeaderIcon = styled.img`
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const HeaderTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 900;
  color: #000000;
  line-height: 1.25;
`;

export const PersuasionCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    #ffffff 0%,
    #ffffff 100%
  ),
  linear-gradient(
    22deg,
    rgba(0, 210, 255, 0.16) 14.6%,
    rgba(58, 123, 213, 0.16) 85.4%
  );
  overflow: hidden;
  min-width: 0;
`;

export const TextCol = styled.div`
  flex: 1;
  min-width: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 900;
  line-height: 1.3;
  color: #000000;
`;

export const CardDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #4a4a4a;
`;

export const GraphicCol = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 60px;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    max-width: 60px;
    max-height: 49px;
    width: auto;
    height: auto;
    object-fit: contain;
  }
`;

export const GraphicShadow = styled.div`
  display: none;
`;
